import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';

const PrivacyPolicy = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar user={user} />

      <div className="max-w-5xl mx-auto px-4 py-24">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] mb-8 transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
          Back to Home
        </button>

        <div className="glass-card p-8 sm:p-10">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 gradient-text">Privacy Policy</h1>
          <p className="text-gray-400 mb-10">How Wearoclub collects, uses, and protects your information.</p>

          <div className="space-y-8 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Information We Collect</h2>
              <p>
                We may collect your name, phone number, email address, booking details, delivery address,
                payment-related references, and any measurements, notes, or preferences you share while using Wearoclub.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">How We Use Your Information</h2>
              <p>
                Your information is used to manage bookings, coordinate designer visits, improve customer support,
                process payments, and deliver a smoother custom-fashion experience.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Sharing and Security</h2>
              <p>
                We only share information when needed to operate the service, such as with assigned designers,
                payment providers, or support tools. We take reasonable steps to protect your data, We sincerely care about your
                privacy and security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#f0d9b5] mb-3">Your Choices</h2>
              <p>
                You can contact us to update account details, request corrections, or ask questions about how your
                information is handled. Continued use of Wearoclub means you agree to this policy.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
